// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css, keyframes } from 'styled-components';
import isEmpty from 'lodash/isEmpty';

const getHeightVal = (aspectRatioObj, variation, isCarouselDesign, carouselFlipListSize) => {
  const { aspectRatioD, aspectRatioT, aspectRatioM } = !isEmpty(aspectRatioObj) && aspectRatioObj;

  const aspectMap = {
    MOBILE: aspectRatioM,
    TABLET: aspectRatioT,
    DESKTOP: aspectRatioD,
  };

  const aspect = aspectMap[variation];

  if (aspect) {
    return `height: 100%;`;
  }

  if (isCarouselDesign && carouselFlipListSize) {
    return `
      width: ${carouselFlipListSize * 0.9}px;
      height: ${carouselFlipListSize}px;
    `;
  }

  return `
    height: 100%;
    max-height: 100%;
  `;
};

const slideIn = keyframes`
  from {
    transform: translateX(5%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOutToRight = keyframes`
  from {
    transform: translateX(80%);
    opacity: 0;
  }
  to {
    transform: translateX(100%);
    opacity: 1;
  }
`;

const slideOutToLeft = keyframes`
  from {
    transform: translateX(-80%);
    opacity: 0;
  }
  to {
    transform: translateX(-100%);
    opacity: 1;
  }
`;

export const AlternateBlock = styled.div`
  display: ${(props) => (props.showList ? 'flex' : 'none')};
  flex-direction: column;
  background-color: #fff;
  width: 100%;
  ${(props) =>
    getHeightVal(
      props?.aspectRatioObj,
      'MOBILE',
      props.isCarouselDesign,
      props.carouselFlipListSize
    )}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) =>
      getHeightVal(
        props?.aspectRatioObj,
        'TABLET',
        props.isCarouselDesign,
        props.carouselFlipListSize
      )}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      getHeightVal(
        props?.aspectRatioObj,
        'DESKTOP',
        props.isCarouselDesign,
        props.carouselFlipListSize
      )}
    ${props => props.isAnimatedList && props.isSlideInAnimation && css`
      transition: transform 0.4s ease, opacity 0.4s ease;
      animation: ${slideIn} 0.4s ease-out forwards;
      z-index: 2;
    `}
    ${props => props.isAnimatedList && props.isSlideOutAnimation && props.isAnimateToLeft && css`
      position: absolute;
      transition: transform 0.4s ease, opacity 0.4s ease;
      animation: ${slideOutToLeft} 0.4s ease-out forwards;
      z-index: 2;
    `}
    ${props => props.isAnimatedList && props.isSlideOutAnimation && !props.isAnimateToLeft && css`
      position: absolute;
      transition: transform 0.4s ease, opacity 0.4s ease;
      animation: ${slideOutToRight} 0.4s ease-out forwards;
      z-index: 2;
    `}
  }
`;

export const BackButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  bottom: 28px;
`;

export const BackButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-transform: uppercase;
  min-height: 50px;
  letter-spacing: 1px;
  font-size: 14px;
  min-width: 65px;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-weight: 400;
  width: auto;
  padding-inline: 32px;
  background: rgb(255, 255, 255);
  color: rgb(74, 74, 74);
  border: 1px solid #ddd;
  &:hover {
    border: 1px solid #000000;
    font-weight: 800;
  }
`;
